import { i18n } from '@ecg-marktplaats/js-react-i18n';
import { nl as dateLocale } from 'date-fns/locale';
import translation from '../../../../locales/nl-NL/translation.json';
import common from '../../../../locales/nl-NL/common.json';
import reviewsDialogUi from '@ecg-marktplaats/reviews-dialog-ui/locales/nl-NL.json';

export default i18n.init({
  lng: 'nl-NL',
  dateLocale,
  translations: {
    translation,
    common,
    reviewsDialogUi,
  },
});
